import canUserBudget from '../../organisations/can/budget';
import canUserManage from '../../organisations/can/manage';
import canUserEdit from '../can/edit';
import canUserPublish from '../can/publish';
import canUserRestore from '../can/restore';

/**
 * @param {Object} me
 * @param {Object} permissions
 * @param {Boolean} isScenario
 * @param {Boolean} isHistorical
 * @returns {Object}
 */
export default function getModel(me, permissions, isScenario, isHistorical) {
  return {
    budget: canUserBudget(me, permissions),
    edit: canUserEdit(me, permissions),
    manage: canUserManage(me, permissions),
    publish: canUserPublish(me, permissions, isScenario),
    restore: canUserRestore(me, permissions, isScenario, isHistorical),
  };
}
